import { Component, OnInit } from '@angular/core';
import { RiskImpact, RiskImpact as IRiskImpact } from "../../_interfaces/RiskImpact.model";
import { RepositoryService } from "../../shared/services/repository.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-risk-impact-list',
  templateUrl: './risk-impact-list.component.html',
  styleUrls: ['./risk-impact-list.component.css']
})
export class RiskImpactListComponent implements OnInit {
  public riskImpacts: RiskImpact[];

  constructor(private repository: RepositoryService,
    private router: Router) { }

    ngOnInit() {
      this.getRiskImpacts();
    }

  public getRiskImpacts() {
      let apiAddress: string = `RiskImpacts`; 
    this.repository.getData(apiAddress)
      .subscribe(res => {
          this.riskImpacts = res as IRiskImpact[];
      });
  }

}
